import { jsx } from "react/jsx-runtime";
import { Box, CircularProgress } from "@mui/material";
function Loader() {
  return /* @__PURE__ */ jsx(
    Box,
    {
      "data-testid": "iframe-loader",
      sx: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 3,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: /* @__PURE__ */ jsx(CircularProgress, {})
    }
  );
}
export {
  Loader
};
//# sourceMappingURL=Loader.js.map
